import React from 'react';
import { render } from 'react-dom';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';

import App from './App';
import HomePage from './pages/Home';
import CountryProfilePage from './pages/CountryProfile';
import StatisticsPage from './pages/Statistics';
import NationalReportsPage from './pages/NationalReports';
import NationalContactsPage from './pages/NationalContacts';
import DiversionLandingPage from './pages/Diversion';
import RegionalOrganizationLandingPage from './pages/RegionalOrganization';
import AssistanceLandingPage from './pages/AssistanceLanding';
import AssistanceCountryPage from './pages/AssistanceCountry';
import SustainableDevGoalsPage from './pages/SustainableDevGoals';
import NoMatch from './pages/NoMatch';

window.React = React; /* for some reason React needs to be defined globally... */

render(
  <Router history={ browserHistory }>
    <Route path="/" component={ App }>
      <IndexRoute component={ HomePage } />
      <Route path="/country-profiles/:id" component={ CountryProfilePage } />
      <Route path="/statistics" component={ StatisticsPage } />
      <Route path="/national-reports" component={ NationalReportsPage } />
      <Route path="/national-contacts" component={ NationalContactsPage } />
      <Route path="/diversion" component={ DiversionLandingPage } />
      <Route path="/regional-organization" component={ RegionalOrganizationLandingPage } />
      <Route
        path="/international-assistance"
        component={ AssistanceLandingPage }
      />
      <Route
        path="/international-assistance/:id"
        component={ AssistanceCountryPage }
      />
      <Route path="/sustainable-development-goals" component={ SustainableDevGoalsPage } />
      {/* This is the "catch-all"-Route */}
      <Route path="*" component={ NoMatch } status={ 404 } />
    </Route>
  </Router>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js